import React from 'react';
import brandLogo from '../../../assets/images/brandlogo.png'
import { useMediaQuery } from 'react-responsive';
import { Divider, Dropdown } from 'rsuite';
import { Link } from 'react-router-dom';
import { FiMenu } from "react-icons/fi";
import './CoordinatorHeader.css'
import DashboardPage from "../../pages/dashboard/DashboardPage"
import UserProfilePage from "../../pages/userprofile/UserProfilePage"
import AddEventPage from "../../pages/addevent/AddEventPage"
import CoordinatorDashboardPage from "../../pages/coordinatordashboard/CoordinatorDashboardPage"
import { logoutCoordinator } from '../../../redux/slices/coordinatorSlices';
import { useNavigate  } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
require('typeface-poppins')

export default function CoordinatorHeader() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const cordinator_id = localStorage.getItem('cordinator_id');
  const dispatch = useDispatch();
  const navigate = useNavigate ();
    
  const SizeDropdown = props => (
    <Dropdown appearance="default" {...props} style={{ zIndex: 10}}>
       <Link to={`/user-profile/${cordinator_id}`} element={<UserProfilePage />}>
      <Dropdown.Item>
       User Name
      </Dropdown.Item> </Link> 
      <Link to="/dashboard" element={<DashboardPage />}>    
      <Dropdown.Item>
        Dashboard
      </Dropdown.Item></Link>
      <Divider style={{margin: '5px 0px'}} />
      <Link to="/add-event" element={<AddEventPage />}>
      <Dropdown.Item>
        Add an Event
      </Dropdown.Item></Link>
      <Link to="/coordinator-dashboard" element={<CoordinatorDashboardPage />}>
      <Dropdown.Item>
         Events
      </Dropdown.Item></Link>
      { /*<Link to="/coordinator-dashboard" element={<CoordinatorDashboardPage />}>
      <Dropdown.Item>
        Favorites
      </Dropdown.Item></Link>
      <Divider style={{margin: '5px 0px'}} />
      <Dropdown.Item>Reports</Dropdown.Item>
      <Dropdown.Item>Orders</Dropdown.Item>
      <Dropdown.Item>Promotional</Dropdown.Item> 
      <Dropdown.Item>Invite an Author</Dropdown.Item>*/}
      <Divider style={{margin: '5px 0px'}} />
      <Link to="#" onClick={handleLogout}>
      <Dropdown.Item>
        Log Out
      </Dropdown.Item></Link>
    </Dropdown>
  ); 
  
  const handleLogout = (e) => {
      e.preventDefault();
      dispatch(logoutCoordinator());
      localStorage.clear();
      sessionStorage.clear();
      navigate('/general-login');
    };

  return (
    <>
    {isMobile ? (
      <header className='coordimobilmainHeader'>
        <div className='coordimobilmainheaderContent'>
          <div className='container'>
            <nav className='coordimobilmainheaderNav coordimobilmainheadernavExpand flex-wrap'>
              <a href="/" className='coordimobilmainheaderLeft me-auto'>
                <div className='coordimobilmainheaderBrand d-flex align-items-start'>
                  <img src={brandLogo} className='coordimobilmainheaderBrandimage img-fluid' />
                  <div className='coordimobilmainheaderbrandTitles'>
                    <h6> AuthorMeet </h6>
                    <p> Powered by: Bookworm Central </p>
                  </div>
                </div>
              </a>
              <div>
                <SizeDropdown className="coordimobilmainheadertopDropdown" placement="bottomEnd" icon={<FiMenu />} noCaret />
              </div>
            </nav> 
          </div>
        </div>
      </header>
      ) : (
      <header className='coordimainHeader'   style={{ position: 'sticky', top: 0, zIndex: 10 }}>
        <div className='coordimainheaderContent'>
          <div className='container'>
            <nav className='coordimainheaderNav coordimainheadernavExpand flex-wrap'>
              <a href="/" className='coordimainheaderLeft me-auto'>
                <div className='coordimainheaderBrand d-flex align-items-start'>
                  <img src={brandLogo} className='coordimainheaderBrandimage img-fluid' />
                  <div className='coordimainheaderbrandTitles'>
                    <h6> AuthorMeet </h6>
                    <p> Powered by: Bookworm Central</p>
                  </div>
                </div>
              </a>
              <SizeDropdown className="coordimainheadertopDropdown" placement="bottomEnd" icon={<FiMenu />} noCaret />
            </nav>
          </div>
        </div>
      </header>
    )}
    </>
  )
}
